import { render, staticRenderFns } from "./insertUrlDialog.vue?vue&type=template&id=2559763a&scoped=true&"
import script from "./insertUrlDialog.vue?vue&type=script&lang=js&"
export * from "./insertUrlDialog.vue?vue&type=script&lang=js&"
import style0 from "./insertUrlDialog.vue?vue&type=style&index=0&id=2559763a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2559763a",
  null
  
)

export default component.exports